<template>
    <div
        v-spinner="loading"
        class="microsoft-auth-form"
    >
        <v-spinner size="large" />
        <v-form
            v-if="edit"
            ref="configForm"
            layout="vertical"
            kind="desc"
            @submit="formSubmit"
        >
            <v-form-item
                :rules="rules.clientId"
                required="client_id必填"
                name="clientId"
                label="client_id"
            >
                <v-textarea
                    v-model="config.client_id"
                    :limit="128"
                    placeholder="请输入"
                    style="width:550px;"
                />
            </v-form-item>
            <v-form-item
                :rules="rules.tenantId"
                required="tenant必填"
                name="tenantId"
                label="tenant"
            >
                <v-textarea
                    v-model="config.tenant_id"
                    :limit="512"
                    placeholder="请输入"
                    style="width:550px;"
                />
            </v-form-item>
            <v-form-item
                :rules="rules.clientSecret"
                required="secret必填"
                name="clientSecret"
                label="secret"
            >
                <v-textarea
                    v-model="config.client_secret"
                    :limit="512"
                    placeholder="请输入"
                    style="width:550px;"
                />
            </v-form-item>
            <v-form-item
                name="redirectUrl"
                required=" "
                label="授权页地址"
            >
                <v-textarea
                    v-model="redirectUrl"
                    :disabled="true"
                    placeholder="填写client_id和tenant后，自动生成授权页地址"
                    style="width:550px;"
                />
            </v-form-item>
            <v-form-item>
                <div class="btn_submit">
                    <v-footer-actionbar size="large">
                        <div slot="footer-actionbar-button">
                            <v-button
                                :loading="loading"
                                type="submit"
                                kind="primary"
                                size="large"
                                style="margin-right: 10px;"
                                :disabled="isDisabled"
                            >
                                保存
                            </v-button>
                            <v-button
                                size="large"
                                @click="cancel"
                            >
                                取消
                            </v-button>
                        </div>
                    </v-footer-actionbar>
                </div>
            </v-form-item>
        </v-form>
        <v-descriptions
            v-else
            class="microsoft-auth-descriptions"
            layout="vertical"
        >
            <v-description-item
                :value="config.client_id || '-'"
                layout="vertical"
                text="client_id"
            />
            <v-description-item
                :value="config.tenant_id || '-'"
                layout="vertical"
                text="tenant"
            />
            <v-description-item
                :value="config.client_secret || '-'"
                layout="vertical"
                text="secret"
            />
            <v-description-item
                :value="config.redirect_url || '-'"
                layout="vertical"
                text="授权页地址"
            />
        </v-descriptions>
        <v-button
            v-if="!edit"
            status="primary"
            @click="changeStatus"
        >
            编辑
        </v-button>

        <v-dialog
            v-model="confirmDialogVisible"
            kind="confirm"
            title="是否要保存当前修改内容?"
            confirm-text="保存"
            class="auth-dialog"
            @confirm="handleDialogConfirm"
            @cancel="handleDialogCancel"
            @close="handleDialogClose"
        />
    </div>
</template>

<script>
import MixinConfig from '../../MixinConfig';
import { cookie } from '@tencent/qd-lib';

export default {
    name: 'MicrosoftAuth',
    mixins: [MixinConfig],
    data() {
        return {
            config: {
                client_id: '',
                tenant_id: '',
                client_secret: '',
                redirect_url: '',
            },

            saveUrl: '/v1/basic/account/integration/saveAuthSetting',
            getUrl: '/v1/basic/account/integration/authSetting',
        };
    },

    computed: {
        redirectUrl() {
            if (!this.config.client_id || !this.config.tenant_id) {
                return '';
            }
            return `https://login.microsoftonline.com/${this.config.tenant_id}/oauth2/v2.0/authorize?client_id=${this.config.client_id}`;
        },

        saveParams() {
            return {
                kfuin: cookie.get('corp_uin') || '',
                auth_providers: [
                    {
                        auth_type: 'microsoft',
                        params: {
                            client_id: this.config.client_id,
                            tenant_id: this.config.tenant_id,
                            client_secret: this.config.client_secret,
                            redirect_url: this.redirectUrl,
                        },
                    },
                ],
            };
        },
    },

    methods: {
        async getInitData() {
            const data = await this.getBeforeConfig(this.getUrl) || {};
            const authProviders = data.auth_providers || [];
            const content = authProviders.find(item => item.auth_type === 'microsoft');
            this.config = {
                client_id: content.params.client_id || '',
                client_secret: content.params.client_secret || '',
                tenant_id: content.params.tenant_id || '',
                redirect_url: content.params.redirect_url || '',
            };
            this.oldConfig = JSON.parse(JSON.stringify(this.config));
        },
    },
};
</script>

<style lang="less" scoped>
.btn_submit {
    position: fixed;
    width: -webkit-fill-available;
    bottom: 0;
    background-color: #fff;
    opacity: 1;
    z-index: 17;
}
</style>
